import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Search } from 'models';
import { Observable, Subject } from 'rxjs';

import { assertExists } from 'lib/common/src/public-api';
import {
  BulkUpdateDialogComponent,
  BulkUpdateDialogData,
} from 'src/app/components/bulk-update-dialog/bulk-update-dialog.component';

export interface BulkUpdateReloadEvent {
  /** Search associated with the reload event. */
  search: Search;
}

/* Bulk Update Service */
@Injectable({
  providedIn: 'root',
})
// eslint-disable-next-line jsdoc/require-jsdoc
export class BulkUpdateService {
  /** Observable that emits when a bulk update reload is requested. */
  requestReload$: Observable<BulkUpdateReloadEvent>;

  private requestReload = new Subject<BulkUpdateReloadEvent>();

  constructor(private dialog: MatDialog) {
    this.requestReload$ = this.requestReload.asObservable();
  }
  /**
   * Prompt user with bulk update selections.
   *
   * @param data Optional data to pre-populate the bulk update dialog.
   */
  promptBulkUpdate(data?: BulkUpdateDialogData): void {
    const dialogReference = this.dialog.open(BulkUpdateDialogComponent, {
      width: '600px',
      disableClose: true,
      data: data,
    });

    if (data?.search) {
      dialogReference.afterClosed().subscribe(() => {
        assertExists(
          data.search,
          'Search must exist in order to request reload after bulk update.'
        );
        this.requestReload.next({ search: data.search });
      });
    }
  }
}
